<template>
    <a :href="`/orders/${order.id}`">
        <div class="p-2"><strong>#{{order.number_order}}</strong> {{order.client?.companyName ?? order?.client?.name}}</div>
        <div class="flex justify-between">
            <div class="bg-green-200 rounded-md p-1"><strong>Total: </strong> ${{order.total}}</div>
            <div class="bg-blue-200 rounded-md p-1"> {{order?.responsible?.first_name}} {{order?.responsible?.last_name}}</div>
        </div>
        <div class="text-center font-bold">
            {{order.date}}
        </div>
    </a>
</template>

<script>
export default {
    props: {
        order: Object
    }
}
</script>